module.exports = __webpack_public_path__ + "img/wood-cube.e267a75e.jpg";